export const frontmatter = {
    "draft": false,
    "title": "Workflows",
    "description": "Complete management of workflows in OnnIA: teams, projects, visual editor, components, variables, credentials, playground, and executions.",
    "sidebar_label": "Overview",
    "sidebar_group": "reference",
    "sidebar_order": 1
}

export const toc = [
    {
        "depth": 2,
        "id": "module-access",
        "value": "Module access"
    },
    {
        "depth": 2,
        "id": "hierarchy-team-project-workflow",
        "value": "Hierarchy: Team → Project → Workflow"
    },
    {
        "depth": 2,
        "id": "team-management",
        "value": "Team management"
    },
    {
        "depth": 3,
        "id": "create-a-team",
        "value": "Create a team"
    },
    {
        "depth": 3,
        "id": "team-profile",
        "value": "Team profile"
    },
    {
        "depth": 2,
        "id": "project-management",
        "value": "Project management"
    },
    {
        "depth": 2,
        "id": "workflow-management",
        "value": "Workflow management"
    },
    {
        "depth": 2,
        "id": "workflow-editor",
        "value": "Workflow editor"
    },
    {
        "depth": 2,
        "id": "available-components",
        "value": "Available components"
    },
    {
        "depth": 2,
        "id": "variables-and-secrets",
        "value": "Variables and secrets"
    },
    {
        "depth": 3,
        "id": "scope",
        "value": "Scope"
    },
    {
        "depth": 3,
        "id": "variables",
        "value": "Variables"
    },
    {
        "depth": 3,
        "id": "secrets",
        "value": "Secrets"
    },
    {
        "depth": 2,
        "id": "credentials",
        "value": "Credentials"
    },
    {
        "depth": 2,
        "id": "mcps",
        "value": "MCPs"
    }
]